import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { share } from 'rxjs';
import { SharedModule } from '../shared.module';
import { NoDataFoundComponent } from "../no-data-found/no-data-found.component";

@Component({
  selector: 'app-search-result-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatListModule, SharedModule, NoDataFoundComponent],
  templateUrl: './search-result-dialog.component.html',
  styleUrls: ['./search-result-dialog.component.scss']
})
export class SearchResultDialogComponent {
  displayedColumns: string[] = [
    'id',
    'storeName',
    'name',
    'studentDetails',
    'agentDetails',
    'applicationStatus',
    'action'
  ];
  constructor(
    public dialogRef: MatDialogRef<SearchResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }
  onViewApplicant(applicant: any): void {
    window.open(applicant.dynamicUrl, '_blank');
  }

}
